<template>
    <div v-show="visible">
        <el-dialog
            title="派发优惠劵"
            :close-on-click-modal="false"
            :close-on-press-escape="!saving"
            :show-close="!saving"
            :visible.sync="visible"
            width="520px"
            :before-close="dialogClose"
        >
            <el-form
                ref="form"
                v-loading="saving"
                element-loading-text="优惠券正在派发中，请稍等..."
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.25)"
                :model="form"
                :rules="rules"
                label-width="100px"
                class="dispatch-form"
            >
                <div class="form-top-right">
                    <el-button type="text" class="record-entry" @click="openRecord">查看派发记录</el-button>
                </div>
                <el-form-item label="派发机构">
                    <el-input v-model="form.orgName" :readonly="true" style="width: 320px;"></el-input>
                </el-form-item>
                <el-form-item prop="productType" label="商品类型">
                    <el-select v-model="form.productType" placeholder="请选择" style="width: 320px;">
                        <el-option :value="1" label="VIP"></el-option>
                        <el-option :value="2" label="SVIP"></el-option>
                        <el-option :value="3" label="BVIP"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="amount" label="金额">
                    <el-input v-model="form.amount" type="number" style="width: 320px;"></el-input>
                </el-form-item>
                <el-form-item prop="startDate" label="开始日期">
                    <el-date-picker
                        v-model="form.startDate"
                        type="date"
                        placeholder="请选择日期"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                        style="width: 320px;">
                    </el-date-picker>
                </el-form-item>
                <el-form-item prop="expiryDate" label="有效日期">
                    <el-date-picker
                        v-model="form.expiryDate"
                        type="date"
                        placeholder="请选择日期"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                        style="width: 320px;">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button :disabled="saving" @click="visible=false">取消</el-button>
                <el-button :disabled="saving" type="primary" @click="save">确定</el-button>
            </span>

            <div v-if="recordVisible">
                <dispatchCouponRecord ref="dispatchCouponRecord" @closed="recordVisible=false"></dispatchCouponRecord>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import http from '../../../../common/http';
    import dispatchCouponRecord from './DispatchCouponRecord.vue';

    export default {
        components:{
            dispatchCouponRecord
        },
        data(){
            return{
                visible:false,
                recordVisible:false,
                saving:false,
                pickerOptions:{
                    disabledDate(time) {
                        const todayStart = new Date();
                        todayStart.setHours(0, 0, 0, 0);
                        return time.getTime() < todayStart.getTime();
                    }
                },
                form:{
                    orgId:"",
                    orgName:"",
                    productType:"",
                    amount:"",
                    startDate:"",
                    expiryDate:""
                },
                rules:{
                    productType: [
                        { required: true, message: '请选择商品类型', trigger: 'change' }
                    ],
                    amount: [
                        { required: true, message: '请输入金额', trigger: 'blur' }
                    ],
                    startDate: [
                        { required: true, message: '请选择开始日期', trigger: 'change' }
                    ],
                    expiryDate: [
                        { required: true, message: '请选择有效日期', trigger: 'change' }
                    ]
                }
            }
        },
        methods:{
            init(data){
                this.visible = true;
                this.saving = false;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.orgId = this.$util.isNotEmpty(data) ? data.orgId : "";
                this.form.orgName = this.$util.isNotEmpty(data) ? data.orgName : "";
                this.form.productType = "";
                this.form.amount = "";
                this.form.startDate = "";
                this.form.expiryDate = "";
            },
            dialogClose(done){
                if (this.saving) {
                    return;
                }
                done();
            },
            openRecord(){
                this.recordVisible = true;
                this.$nextTick(() => {
                    this.$refs['dispatchCouponRecord'].init({
                        orgName: this.form.orgName
                    });
                })
            },
            save(){
                this.$refs['form'].validate((valid) => {
                    if(!valid){
                        return;
                    }
                    this.saving = true;
                    let url = this.deptDispatchCouponUrl;
                    let data = {
                        orgId: this.form.orgId,
                        productType: this.form.productType,
                        amount: this.form.amount,
                        startDate: this.form.startDate,
                        expiryDate: this.form.expiryDate
                    };
                    console.log(JSON.stringify(data));
                    this.apiPost(url, data).then((res) => {
                        this.saving = false;
                        if(res.status == 200){
                            this.$commonFn.showTip(res.message,1);
                            this.visible=false;
                        }else{
                            this.$commonFn.showTip(res.message,3);
                        }
                    }, (err) => {
                        this.saving = false;
                        console.log(err);
                    });
                });
            }
        },
        mixins: [http]
    }
</script>

<style scoped>
.dispatch-form{
    position: relative;
}
.form-top-right{
    position: absolute;
    right: -16px;
    top: -25px;
    z-index: 2;
}
.record-entry{
    padding: 0;
    color: #e8aa38;
    font-weight: 700;
    font-size: 15px;
}
</style>




// WEBPACK FOOTER //
// src/components/page/sys/dept/DispatchCoupon.vue